"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.takerValue = exports.makerValue = void 0;
var makerValue = exports.makerValue = 'Maker';
var takerValue = exports.takerValue = 'Taker';